<template>
  <div style="display: flex">
      <span>{{ props.value }}</span>
      <math-tooltip v-if="authStore.isSuperUser" :name="props.field" :title="$t(`entities.${props.type}.fields.${props.field}`)"/>
  </div>
</template>

<script lang="ts" setup>
import { useAuthStore } from '@/stores/authStore';
import MathTooltip from './MathTooltip.vue';

const props = defineProps({
  type: { type: String, default: '' },
  field: { type: String, default: '' },
  value: { type: String, default: '' },
})

  const authStore = useAuthStore();
</script>
